$(document).ready(function() {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function(){
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function(e){
		var target = $(this).attr("target"),
			url = $(this).attr("href");

		if (target == "_blank") {
			window.open(url);
		}else {
			window.location = url;
		}
        return false;
    }).click(function(){
		var target = $(this).find("a.js-click-item-link").attr("target"),
			url = $(this).find("a.js-click-item-link").attr("href");

		if (target == "_blank") {
			window.open(url);
		}else {
			window.location = url;
		}
        return false;
    });​



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page
    // *
    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                scrollTo(target);
            return false;
            }
        }
    });

    function scrollTo(element) {
        $('html, body').animate({
            scrollTop: element.offset().top - 100
        }, 1000);

        // move keyboard focus to the target as well (e.g. skip link)
        if (!element.is('a[href], button, input, select, textarea, [tabindex]')) {
            element.attr('tabindex', '-1');
        }
        element[0].focus({ preventScroll: true });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * keyboard helpers
    // *
    // * focusable elements inside a container and
    // * keep the tab focus inside open dialogs/menus
    // *
    function getFocusable($container) {
        return $container.find('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(':visible');
    }

    function trapFocus($container, e) {
        var $focusable = getFocusable($container),
            first = $focusable.first()[0],
            last = $focusable.last()[0];

        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    }

    // hide the focus ring while the mouse/touch is used (form fields get :focus-visible on click too)
    $(document).on("mousedown touchstart", function() {
        $("html").addClass("is-pointer");
    }).on("keydown", function(e) {
        if (e.key === "Tab" || e.key === "ArrowUp" || e.key === "ArrowDown") {
            $("html").removeClass("is-pointer");
        }
    });

    // links with role="button" should also react to the space key
    $(document).on("keydown", 'a[role="button"]', function(e) {
        if (e.key === " ") {
            e.preventDefault();
            this.click();
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements(){
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function(){
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            }else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function() {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function() {
        if(location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        }else {
            $(this).attr('target','_blank');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    var $nav = $(".js-nav"),
        $navToggle = $(".header__navButton.js-navbutton");

    function toggleNav(open) {
        $(".js-navbutton, .js-nav").toggleClass("active", open);
        $("body, html").toggleClass("freeze", open);
        $navToggle.attr("aria-expanded", open);

        if (open) {
            setTimeout(function() {
                getFocusable($nav).first().focus();
            }, 50);
        } else if ($.contains($nav[0], document.activeElement)) {
            $navToggle.focus();
        }
    }

    $(".js-navbutton").click(function(){
        toggleNav(!$nav.hasClass("active"));
    });

    $nav.on("keydown", function(e) {
        if (e.key === "Tab") {
            trapFocus($nav, e);
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * popup
	// *
	// *
    var $popup = $(".js-popupform"),
        $popupOpener = null;

    function togglePopup(open) {
        $(".js-popupform, .js-popupform-button").toggleClass("active", open);
        if(!$nav.hasClass("active")) {
            $("body, html").toggleClass("freeze", open);
        }
        $("button.asideButton").attr("aria-expanded", open);

        if (open) {
            if (!$.contains($popup[0], document.activeElement)) {
                $popupOpener = $(document.activeElement);
            }
            setTimeout(function() {
                var $invalid = $popup.find('[aria-invalid="true"]');
                ($invalid.length ? $invalid : getFocusable($popup.find("form"))).first().focus();
            }, 50);
        } else if ($popupOpener && $popupOpener.length) {
            $popupOpener.focus();
            $popupOpener = null;
        }
    }

    $(".js-popupform-button").click(function(e){
        e.preventDefault();
        togglePopup(!$popup.hasClass("active"));
    });

    $popup.on("keydown", function(e) {
        if (e.key === "Tab") {
            trapFocus($popup, e);
        }
    });

    $(".js-popupform-button.error").first().trigger("click");


    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * escape key
	// *
	// * closes the top-most open popup, menu or dropdown
	// *
    $(document).on("keydown", function(e) {
        if (e.key !== "Escape") {
            return;
        }

        if ($popup.hasClass("active")) {
            togglePopup(false);
        } else if ($nav.hasClass("active")) {
            toggleNav(false);
        } else if ($(".js-header-language").hasClass("active")) {
            toggleLanguage(false);
            $(".js-header-language-button").focus();
        }
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * slider
	// *
	// *
	var $slider = $(".js-slider");

	if ($slider.length){
		$slider.each(function(){
			$(this).slick({
				fade: false,
				dots: false,
				infinite: false,
				arrows: true,
				autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                pauseOnFocus: true,
				speed: 1000,
				prevArrow: $(this).parent().find(".js-slider-nav-prev"),
				nextArrow: $(this).parent().find(".js-slider-nav-next"),
			});
		});
	}


    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * slider
	// *
	// *
	var $teaserCarousel = $(".js-teasercarousel");

	if ($teaserCarousel.length){
		$teaserCarousel.each(function(){
			$(this).slick({
				fade: false,
				dots: false,
				infinite: true,
				arrows: true,
                variableWidth: true,
				autoplay: true,
				autoplaySpeed: 3500,
                pauseOnHover: true,
                pauseOnFocus: true,
				speed: 1000,
				prevArrow: $(this).siblings(".js-slider-nav-prev"),
				nextArrow: $(this).siblings(".js-slider-nav-next"),
			});
		});
	}



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").each(function(i){
        var id = "accordion-content-" + i;
        $(this).attr("aria-controls", id).siblings().attr("id", id);
    });

    $(".js-accordion-button").click(function(){
        $(this).toggleClass("active").siblings().slideToggle();
        $(this).attr("aria-expanded", $(this).hasClass("active"));

        $('html, body').animate({
            scrollTop: ($(this).offset().top - 200)
        }, 400);
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header language
    // *
    // *
    function toggleLanguage(open) {
        $(".js-header-language").toggleClass("active", open);
        $(".js-header-language-button").attr("aria-expanded", open);
    }

    $(".js-header-language-button").click(function(){
        toggleLanguage(!$(".js-header-language").hasClass("active"));
    });

    // close when the keyboard focus leaves the dropdown
    $(".js-header-language").on("focusout", function(e){
        if (e.relatedTarget && !$.contains(this, e.relatedTarget)) {
            toggleLanguage(false);
        }
    });

    $(window).on("scroll", function(){
        if ($(".js-header-language").hasClass("active")) {
            toggleLanguage(false);
        }
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * video
    // *
    // *
    $(".js-video").each(function() {
        var link = $(this).find(".js-video-link").data("href");
        $(this).attr("href",link);
    })


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * jobSearch
    // *
    // *
    //toggle dropdown on input
    $(".js-job-search-city").on("input", function(){
        var city = $(this).val();

        // do ajax request
        $.ajax({
            url : "/assets/components/site/connector.php?action=getcities",
            type: 'GET',
            data: { city : city }
        }).done(function(data){
            if(data.status == 'success'){
                // do nothing
                console.log(data);

                // add cities to list
                $(".js-jobcitylist").html(data.data);

            }else if(data.status == 'error'){
                // handle Error
                console.log('Error:' + data);
            }
        });

        // show list only with input value
        toggleCityList(!!$(this).val());
    });

    function toggleCityList(open) {
        $(".js-jobcitylist").toggleClass("active", open);
        $(".js-job-search-city").attr("aria-expanded", open);
    }

    // copy option name in input field
    function selectCity($item) {
        $(".js-job-search-city").val($.trim($item.text())).focus();
        toggleCityList(false);
    }

    $(".js-jobcitylist").on("click", ".js-jobcitylist-item", function() {
        selectCity($(this));
    })

    // keyboard: arrow down opens the list, arrows move, enter selects, escape closes
    $(".js-job-search-city").on("keydown", function(e) {
        if (e.key === "ArrowDown" && $(".js-jobcitylist-item").length) {
            e.preventDefault();
            toggleCityList(true);
            $(".js-jobcitylist-item").first().focus();
        } else if (e.key === "Escape") {
            toggleCityList(false);
        }
    });

    $(".js-jobcitylist").on("keydown", ".js-jobcitylist-item", function(e) {
        if (e.key === "ArrowDown") {
            e.preventDefault();
            $(this).next().focus();
        } else if (e.key === "ArrowUp") {
            e.preventDefault();
            $(this).prev().length ? $(this).prev().focus() : $(".js-job-search-city").focus();
        } else if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            selectCity($(this));
        } else if (e.key === "Escape") {
            e.stopPropagation();
            toggleCityList(false);
            $(".js-job-search-city").focus();
        }
    });

    // slide up dropdown on mouseleave and when the focus leaves the field
    $(".js-job-search-wrapper").mouseleave(function() {
        toggleCityList(false);
    }).on("focusout", function(e) {
        if (e.relatedTarget && !$.contains(this, e.relatedTarget)) {
            toggleCityList(false);
        }
    })

});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function(){
    var scroll = $(window).scrollTop();
    if (scroll > 100) {
        $(".js-header").addClass("collapse");
    }

    if (scroll <= 0) {
        $(".js-header").removeClass("collapse");
    }


});
